// Implements: F-UIX-019
/**
 * The status panel's one read, through the shared query cache.
 *
 * The panel and the notices above the page read the same key, so opening `/admin` sends one
 * request. It is read on opening and when the admin asks for it again ("Actualizar"), never
 * on a timer: a tab left open is not traffic.
 */

import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import type { ApiError } from "../../../shared/api/ApiError";
import type { SystemStatusView } from "../../../types/status";
import { fetchSystemStatus } from "../api/statusApi";

export const SYSTEM_STATUS_KEY = ["admin", "status"] as const;

export function useSystemStatus(): UseQueryResult<SystemStatusView, ApiError> {
  return useQuery<SystemStatusView, ApiError>({
    queryKey: SYSTEM_STATUS_KEY,
    queryFn: ({ signal }) => fetchSystemStatus(signal),
  });
}
